import Box from '@mui/material/Box';
import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import Typography from '@mui/material/Typography';

interface ProgressMessageBoxProps {
  message: string;
}

const ProgressMessageBox = (props: ProgressMessageBoxProps) => (
  <Box p={2}>
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={1}
      wrap="nowrap"
    >
      <Grid>
        <CustomLoadingProgress />
      </Grid>
      <Grid>
        <Typography variant="h6" color="primary" align="center">
          {props.message}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

export default ProgressMessageBox;
